import React from "react";
import { createPortal } from "react-dom";
import { injectGlobal } from "styled-components";

injectGlobal`
  body.modal-open {
    overflow: hidden;

    @media only print {
      .app-wrapper {
        display: none;
      }
    }
  }
`;

class ModalManager {
  currentModals = [];

  ensureBodyClass() {
    document.body.classList.toggle("modal-open", this.currentModals.length);
  }

  addModal(el) {
    this.currentModals.push(el);
    this.ensureBodyClass();
  }

  removeModal(el) {
    const index = this.currentModals.indexOf(el);
    if (index > -1) {
      this.currentModals.splice(index, 1);
    }
    this.ensureBodyClass();
  }

  toggleModal(el, toggle) {
    toggle ? this.addModal(el) : this.removeModal(el);
  }
}

const manager = new ModalManager();

export default function modalWrapper(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.el = document.createElement("div");
    }

    componentDidMount() {
      document.body.appendChild(this.el);
      manager.toggleModal(this.el, this.props.isOpen);
    }

    componentWillUnmount() {
      document.body.removeChild(this.el);
      manager.removeModal(this.el);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.isOpen !== nextProps.isOpen) {
        manager.toggleModal(this.el, nextProps.isOpen);
      }
    }

    render() {
      return createPortal(<Component {...this.props} />, this.el);
    }
  };
}



// WEBPACK FOOTER //
// ./src/hocs/modalWrapper.js